import { render, staticRenderFns } from "./TranslationPanel.vue?vue&type=template&id=585687f8&scoped=true&"
import script from "./TranslationPanel.vue?vue&type=script&lang=js&"
export * from "./TranslationPanel.vue?vue&type=script&lang=js&"
import style0 from "./TranslationPanel.vue?vue&type=style&index=0&id=585687f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585687f8",
  null
  
)

export default component.exports